/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：32__part-0
 */

"use strict"

import { W } from "./index__part-1"
import { ge, ye, be, we, xe, Ce, Oe, ke, Se, Te, Be, De, Ie, Re, Fe, Ne, Me, Le, je, Ue, He, Ge, Qe, We, Ke, Xe, Ye, qe, $e, Je, et, tt, nt, rt } from "./index__part-2"
import /* [auto-meaningful-name] */Module_1338 from /* 1338 */"./1338"
import /* [auto-meaningful-name] */Module_1337 from /* 1337 */"./1337"
var r = {}
Object.defineProperty(r, "isMobile", {
  get: function () {
    return W
  }
})
Object.defineProperty(r, "EventEmitter", {
  get: function () {
    return Module_1337
  }
})
Object.defineProperty(r, "earcut", {
  get: function () {
    return Module_1338
  }
})
Object.defineProperty(r, "BaseTextureCache", {
  get: function () {
    return Xe
  }
})
Object.defineProperty(r, "CanvasRenderTarget", {
  get: function () {
    return $e
  }
})
Object.defineProperty(r, "DATA_URI", {
  get: function () {
    return et
  }
})
Object.defineProperty(r, "ProgramCache", {
  get: function () {
    return We
  }
})
Object.defineProperty(r, "TextureCache", {
  get: function () {
    return Ke
  }
})
Object.defineProperty(r, "clearTextureCache", {
  get: function () {
    return qe
  }
})
Object.defineProperty(r, "correctBlendMode", {
  get: function () {
    return Te
  }
})
Object.defineProperty(r, "createIndicesForQuads", {
  get: function () {
    return Re
  }
})
Object.defineProperty(r, "decomposeDataUri", {
  get: function () {
    return tt
  }
})
Object.defineProperty(r, "deprecation", {
  get: function () {
    return Qe
  }
})
Object.defineProperty(r, "destroyTextureCache", {
  get: function () {
    return Ye
  }
})
Object.defineProperty(r, "determineCrossOrigin", {
  get: function () {
    return nt
  }
})
Object.defineProperty(r, "getBufferType", {
  get: function () {
    return Fe
  }
})
Object.defineProperty(r, "getResolutionOfUrl", {
  get: function () {
    return rt
  }
})
Object.defineProperty(r, "hex2rgb", {
  get: function () {
    return xe
  }
})
Object.defineProperty(r, "hex2string", {
  get: function () {
    return Ce
  }
})
Object.defineProperty(r, "interleaveTypedArrays", {
  get: function () {
    return Ne
  }
})
Object.defineProperty(r, "isPow2", {
  get: function () {
    return Le
  }
})
Object.defineProperty(r, "isWebGLSupported", {
  get: function () {
    return we
  }
})
Object.defineProperty(r, "log2", {
  get: function () {
    return je
  }
})
Object.defineProperty(r, "nextPow2", {
  get: function () {
    return Me
  }
})
Object.defineProperty(r, "premultiplyBlendMode", {
  get: function () {
    return Se
  }
})
Object.defineProperty(r, "premultiplyRgba", {
  get: function () {
    return Be
  }
})
Object.defineProperty(r, "premultiplyTint", {
  get: function () {
    return De
  }
})
Object.defineProperty(r, "premultiplyTintToRgba", {
  get: function () {
    return Ie
  }
})
Object.defineProperty(r, "removeItems", {
  get: function () {
    return Ue
  }
})
Object.defineProperty(r, "rgb2hex", {
  get: function () {
    return ke
  }
})
Object.defineProperty(r, "sayHello", {
  get: function () {
    return be
  }
})
Object.defineProperty(r, "sign", {
  get: function () {
    return He
  }
})
Object.defineProperty(r, "skipHello", {
  get: function () {
    return ye
  }
})
Object.defineProperty(r, "string2hex", {
  get: function () {
    return Oe
  }
})
Object.defineProperty(r, "trimCanvas", {
  get: function () {
    return Je
  }
})
Object.defineProperty(r, "uid", {
  get: function () {
    return Ge
  }
})
Object.defineProperty(r, "url", {
  get: function () {
    return ge
  }
})
export { r }
